/**
 * Finds and returns a specified `DateProperty` from an `Intl.DateTimeFormat.formatToParts` response.
 * @hidden
 * @param parts The `Intl.DateTimeFormat.formatToParts` response.
 * @param property The name of the requested `DateProperty`.
 */
export const getValueForDateProperty = (parts, property) => {
    const requestedPart = parts.find(part => part.type.toLowerCase() === property.toLowerCase());
    return requestedPart ? requestedPart.value : ''; // Cannot find the requested value
};
//# sourceMappingURL=get-value-for-date-property.js.map